import { useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function PaidIndemnityForm() {
  const location = useLocation()
  console.log('PaidIndemnityForm rendered: ', location)
  
  const [searchParams] = useSearchParams()
  const reportVersion = searchParams.get('in_report_version')

  let init = {
    dueDateFrom: '',
    dueDateTo: '',
    closedDateFrom: '',
    closedDateTo: '',
    amountOperator: '',
    settlementAmount: '',
    status: [],
    checkNumber: 'Y',
    addColumns: '',
    reportVersion: reportVersion,
    exposureType: [],
  }

  const navigate = useNavigate()
  init = initialFormValues('PaidIndemnityForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log({inputs})
    submitFormValues('PaidIndemnityForm', navigate, inputs, 'liberty.settlement')
  }

  let exposureTypeSelect = ''
  if (reportVersion === '2') {
    exposureTypeSelect = <CustomSelectListInput label="Exposure Type" handleChange={handleInputChange} modelName="Asbestos" entityName="exposure_type" name='exposureType' multiple={true} defaultValue={inputs.exposureType} />
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Paid Indemnity Report' />
            <tbody>
              <DateRangeInput label='Payment Due Date' name='dueDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.dueDateFrom} defaultValueTo={inputs.dueDateTo} />
              <DateRangeInput label='Date Closed' name='closedDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.closedDateFrom} defaultValueTo={inputs.closedDateTo} />
              <tr>
                <td><b>Settlement Amount</b></td>
                <td>
                  <Input
                    type="select"
                    name="amountOperator"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.amountOperator}
                  >
                    <option value={''}></option>
                    <option value={'>'}>Greater Than</option>
                    <option value={'='}>Equal To</option>
                    <option value={'<'}>Less Than</option>
                  </Input>
                  <Input style={{ width: 'auto', display: 'inline-block' }} name="settlementAmount" onChange={handleInputChange} defaultValue={inputs.settlementAmount} />
                </td>
              </tr>
              <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='status' multiple={true} defaultValue={inputs.status} />
              {exposureTypeSelect}
              <tr>
                <td colSpan="2">
                  <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.checkNumber} name="checkNumber" onChange={handleInputChange} /> Include only settlement detail records that have check numbers <span><br /></span>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.addColumns} name="addColumns" onChange={handleInputChange} /> Include additional columns <span><br /></span>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

